export default {
  name: 'Call to action section - 1',
  tab: 'call to action',
  type: 'content-default-section',
  content: {
    title: 'Content section',
    introtext:
      '<p>Aenean lacinia bibendum nulla sed consectetur. Sed posuere consectetur est at lobortis. Etiam porta sem malesuada magna mollis euismod. Morbi leo risus, porta ac consectetur ac.</p>',
    image: '',
    buttons:
      '[{"button-text":"Call to action","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"button-text":"External link","button-link":"#","button-style":"outlined","button-background-color":"var(--primary-color)","button-text-color":"inherit"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'md',
    'content-horizontal-alignment': 'center',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {}
}
